/*
Wydanie vouchera po przekroczeniu progu: POST /api/coupon-campaigns/{kampania}/claims
(CouponCampaignClaimController). Backend pilnuje jednego kodu na telefon i e-mail
(po normalizacji), wydaje kody do wyczerpania puli i wysyła kod wyłącznie
mailem - odpowiedź 201 to samo { success: true }, kodu w niej nie ma.

Każda porażka to ClaimError z `type`:
- already_claimed / pool_exhausted / closed - errors.claim[0] z backendu,
- validation - błędy pól (errors.email, errors.phone, ...) w `fields`,
- throttled - 429 (limit zgłoszeń z jednego IP),
- generic - wszystko inne, łącznie z brakiem sieci.
*/

const CLAIM_TYPES = ['already_claimed', 'pool_exhausted', 'closed'];

export class ClaimError extends Error {
    constructor(type, fields = {}) {
        super(type);
        this.type = type;
        this.fields = fields;
    }
}

async function readJson(response) {
    try {
        return await response.json();
    } catch (e) {
        return null;
    }
}

// `payload` idzie 1:1 jako JSON - kształt składa result.js.
export async function claimVoucher(url, payload) {
    let response;

    try {
        response = await fetch(url, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(payload),
        });
    } catch (e) {
        throw new ClaimError('generic');
    }

    if (response.ok) {
        return;
    }

    if (response.status === 429) {
        throw new ClaimError('throttled');
    }

    const errors = (await readJson(response))?.errors;

    if (response.status === 422 && errors) {
        const claim = errors.claim?.[0];

        if (claim) {
            throw new ClaimError(CLAIM_TYPES.includes(claim) ? claim : 'generic');
        }

        throw new ClaimError('validation', errors);
    }

    throw new ClaimError('generic');
}
